<template>
  <div>
    <div class="tb-form-group">
      <label class="tb-label">URL</label>

      <div v-if="provider">
        Field mapped to data source.
      </div>

      <input
        v-else
        type="text"
        :class="{
          'tb-input': true,
        }"
        v-model.lazy="_url"
        data-entity="producer-editor-qrCodeUrl"
        @paste.prevent="onPaste"
      />

      <span v-show="qrCodeUrlError" class="text-danger">Invalid url format</span>
    </div>

    <template v-if="!provider">
      <div v-if="shortenerEnabled" class="tb-form-group">
        <!-- TODO: Finalize copy for tooltip -->
        <label
          title="URL used by the QR Code to enable tracking of scans and more analytics."
          class="tb-label"
        >
          Short URL

          <span class="fas fa-info-circle" />
        </label>

        <div class="no-wrap--ellipsis">
          {{ generatingShortUrl ? 'Generating...' : _shortUrl }}
        </div>

        <div v-if="shortenerError" class="text-danger">
          {{ shortenerError }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import { mapState } from 'vuex';
import catchify from 'catchify';
import Shortener from '../../services/shortener';

const isValidUrl = (url) => {
  try {
    // eslint-disable-next-line no-new
    new URL(url);
  } catch (e) {
    return false;
  }

  return true;
};

export default {
  name: 'QRCodeUrl',
  props: {
    url: {
      required: true,
      type: String,
    },
    shortUrl: {
      required: true,
      type: String,
    },
    item: {
      type: Object,
      required: true,
    },
    element: {
      type: Object,
      required: true,
    },
    provider: {
      type: Boolean,
      default: false,
    },
    entityId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      generatingShortUrl: false,
      shortenerError: null,
      shortenerEnabled: process.env.QR_CODE_SWITCH === 'ON',
      qrCodeUrlError: false,
      settingAffiliate: false,
    };
  },
  computed: {
    ...mapState({
      production(state) {
        return state.production.production;
      },
    }),
    _url: {
      get() {
        return this.url;
      },
      set(v) {
        this.$emit('update:url', v);
      },
    },
    _shortUrl: {
      get() {
        return this.shortUrl;
      },
      set(v) {
        this.$emit('update:short-url', v);
      },
    },
  },
  watch: {
    async _url(newVal) {
      this.qrCodeUrlError = false;
      if (isValidUrl(newVal)) {
          await this.shortenUrl(newVal);

      } else {
        this.qrCodeUrlError = true;
      }
    },
  },
  methods: {
    async shortenUrl(url) {
      this.shortenerError = null;

      this.generatingShortUrl = true;

      const [err, resp] = await catchify(
        Shortener.getShortURL(url, {
          user: this.production.owner,
          production: {
            id: this.production.id,
            title: this.production.title,
          },
          item: this.item,
          element: this.element,
        }),
      );

      if (err) {
        // TODO: Bubble up shortener errors to global state
        // so we can show error icons on the timeline item
        this.shortenerError = err?.message || 'Failed to shorten URL';
        this.generatingShortUrl = false;
        return;
      }

      const { shortUrl } = resp.data;

      this._shortUrl = shortUrl;
      this.generatingShortUrl = false;
    },
    selectProduct(v) {
      this._url = v.Url;
      this._productInfo = v;
    },
    onPaste(e) {
      const { clipboardData } = e;
      const pastedData = clipboardData.getData('Text');
      this._url = pastedData;

      this._productInfo = {};
    },
  },
};
</script>

<style lang="scss">
.affiliate-controls {
  @media screen and (max-width: 91.5625rem) {
    & > .tb-btn + .tb-btn {
      margin-left: 0;
      margin-top: 0.5rem;
    }
  }
}

.affiliate-name {
  &:hover {
    overflow: visible;
  }
}

.affiliate-image {
  width: 5rem;
  height: 5rem;
  border-radius: 3px;
  margin-right: 0.5rem;
  object-fit: contain;
}
</style>
